/*** 
 * 创建人：李珊
 * 时间：2020-12-11
 * 描述：实体资源-查看资源详情
 * 更新说明:
 */
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { KmsService } from '../../../kms.service';
import Viewer from 'viewerjs';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { KmsEnum } from '../../../serves/kms-enum';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
declare var $;

@Component({
  selector: 'app-resources-detail',
  templateUrl: './resources-detail.component.html',
  styleUrls: ['./resources-detail.component.css']
})
export class ResourcesDetailComponent implements OnInit {

  /**
    * 文件详细信息
    */
  @Input() param:any;

  /**
   * 抛出事件
   */
  @Output() callback = new EventEmitter(); 

  /**
   * 文件信息
   * @ignore
   */
  fileInfo:any ={} 

  /**
   * 文件类型--默认为图片
   * @ignore
   */
  fileType:string = "2" 

  /**
   * 图片的后缀
   * @ignore
   */
  imgSuffix:any[] = ['jpg','jpeg','png','bmp','gif'] 

  /**
   * word 或者是 excel 的后缀
   * @ignore
   */
  editSuffix:any[] = ['doc','docx','xls','xlsx','pdf','txt'] 

  /**
   * 视频文件 的后缀
   * @ignore
   */
  videoSuffix:any[] = ['mp4','ogg','avi','wmv','flv','3gp','rmvb'] 

  /**
   * 音频文件 的后缀
   * @ignore
   */
  audioSuffix:any[] = ['mp3']

  /**
   * 音频文件 的后缀
   * @ignore
   */
  zipSuffix:any[] = ['zip','rar']

  /**
   * iframe的id
   * @ignore
   */
  ids:string

  /**
   * 文件路径
   * @ignore
   */
  src:string

  /**
   * 详细信息定位
   * @ignore
   */
  right:string = '0'

  /**
   * 文件展示宽度
   * @ignore
   */
  width:string = '45%'

  /**
   * 文件详细信息显示按钮
   * @ignore
   */
  showBtnRight:string = '-50px'

  /**
   * 图片是原图吗，默认不是
   * @ignore
   */
  isOriginalImage:boolean = false

  /**
   * 播放状态，false-->暂停 ， true-->播放
   * @ignore
   */
  playStatus:boolean = false

  /**
   * 如果是图片，就创建图片预览对象
   * @ignore
   */
  gallery:any

  /**
   * 如果是压缩包，这就是压缩包内的文件列表数据
   * @ignore
   */
  zipList:any[] = []

  /**
   * 自定义标签中文数组
   * @ignore
   */
  labelNameList:any[] = []

  /**
  * 不需要任何操作按钮，默认需要
  * @ignore
  */
  noOperate:boolean = false

  /**
   * 提示框对象
   * @ignore
   */
  @ViewChild("trim") trim: SwMassageConfirmComponent
  

  constructor(
    private kmsService:KmsService,
    private box: SwMassageBoxService,
    private instanceModuleService: InstanceModuleService) { }

  ngOnInit() {
    this.src = this.fileInfo.src
    this.fileType = '2'
    this.fileInfo = this.param
    //先对 this.src 赋值，避免图片路径为空报错
    this.src = this.fileInfo.src
    this.kmsService.queryFileById(this.fileInfo.fileInfoId).subscribe(res=>{
      this.fileInfo = res.data
      let fileTypes = this.instanceModuleService.getResourceTypeOptions();
      if(this.fileInfo.fileCategory == fileTypes[1].id){
        //如果是图片
        this.src = environment.staticFileUrl + this.fileInfo.fileThumbnail
        //如果文件类型是 图片
        this.fileType = '2'
      } else if(this.fileInfo.fileCategory == fileTypes[3].id){
        //如果文件类型是视频
        this.src = environment.staticFileUrl + this.fileInfo.filePath;
        this.fileType = '4'
      } else if(this.fileInfo.fileCategory == fileTypes[2].id){
        //如果文件类型是音频
        this.src = environment.staticFileUrl + this.fileInfo.filePath;
        this.fileType = '3'
      } else{
        this.fileType = ""  //提示该类型文件不支持预览
      }
      if(this.fileInfo.fileCategory){
        fileTypes.forEach(v => {
          if(this.fileInfo.fileCategory == v.id){
            this.fileInfo['fileCategoryName'] = v.text
          }
        });
      }
    })
  }

  ngAfterViewInit(){
    let interval = setInterval(()=>{
      if(this.fileType){
        this.initViewer()
        clearInterval(interval)
      }
    },10)
  }

  //初始化图片预览
  initViewer(){
    if(this.fileType == '2'){
      //创建预览对象
      this.gallery = new Viewer(document.getElementById('image'),
      {
        backdrop:false,
        inline:true,
        navbar: true,
        button: false,  //不显示右上角关闭按钮
        title: false,
        keyboard: false, 
        fullscreen:false,  //不全屏播放
        // className:'viewer-auto',
        show: function (){  
          // 动态加载图片后，更新实体
          this.gallery.update(); 
        },
        shown: function() {
        }, 
        view: function() {},
        viewed:function () {
          // this.gallery.zoomTo(1);
        },
        hidden: function() {},
      });
      //手动调用show方法
      this.gallery.show(true)  

    }
  }

  /**
    * 转化文件后缀
    * 将doc 改成pdf
    * 将xslx改成html
  * @ignore
    */
  fileSuffixConversion(filePath){
    let fileSuffix = filePath.split('.');
    switch(fileSuffix[fileSuffix.length-1].toLowerCase()){
      case "docx" : fileSuffix[fileSuffix.length-1] = "pdf";  break;
      case "doc"  : fileSuffix[fileSuffix.length-1] = "pdf"; break;
      case "xls"  : fileSuffix[fileSuffix.length-1] = "html";break;
      case "xlsx" : fileSuffix[fileSuffix.length-1] = "html";  break;
    }
    let url ="";
    fileSuffix.forEach(path => {
      url +=path+"."
    });
    return url.substring(0,url.length-1)
  }

  /**
   * 点击关闭
   * @ignore
   */
  close(){
    if(this.fileType == '2'){
      this.gallery.destroy()  //销毁预览对象
    }
    this.callback.emit()
  }

  /**
   * 点击右侧详细信息关闭按钮
   * @ignore
   */
  hidden(event){
    this.right = '-27%'
    this.width = '70%'
    this.showBtnRight = '0px'
    setTimeout(() => {
      if(this.fileType == '2'){
        this.gallery.resize()
      } 
    }, 150);
  }

  /**
   * 点击右侧详细信息关闭按钮
   * @ignore
   */
  show(event){
    this.right = '0'
    this.width = '45%'
    this.showBtnRight = '-50px'
    setTimeout(() => {
      if(this.fileType == '2'){
        this.gallery.resize()
      } 
    }, 150);
  }

  /**
   * 点击查看原图按钮
   * @ignore
   */
  clickView(){
      //将图片地址切换为原图的
      this.src = environment.staticFileUrl + this.fileInfo.filePath
      //将按钮隐藏
      this.isOriginalImage = true
      if(this.fileType == '2'){
        //先将图片预览组件销毁，再重新创建
        this.gallery.destroy()
        this.initViewer()
      } 
  }



  //播放
  play(event){
    this.playStatus = true
  }

  //暂停
  pause(event){
    this.playStatus = false
  }
}

